import api from './api';

export const getTicketsByProject = async (projectId) => {
    const res = await api.get(`/ProjectTickets/project/${projectId}`);
    return res.data;
};

export const getRecentTickets = async (limit = 25) => {
    const res = await api.get(`/ProjectTickets/recent?limit=${limit}`);
    return res.data;
};

export const createTicket = async (data) => {
    const res = await api.post('/ProjectTickets', data);
    return res.data;
};

export const updateTicket = async (id, data) => {
    const res = await api.patch(`/ProjectTickets/${id}`, data);
    return res.data;
};

export const deleteTicket = async (id) => {
    const res = await api.delete(`/ProjectTickets/${id}`);
    return res.data;
};

/** Planning fields on a ticket. Only the keys passed are written, so dragging a card sends
 *  `{status}` alone and nothing else on the row is touched. */
export const updateTicketPlanning = async (id, patch) => {
    const res = await api.patch(`/ProjectTickets/${id}`, patch);
    return res.data;
};

/** Persist a hand-arranged order; the list must name every task of the project. */
export const reorderTickets = async (projectId, order) => {
    const res = await api.patch(`/ProjectTickets/project/${projectId}/order`, { order });
    return res.data;
};
